import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changePassword,
  // resetChangePasswordState,
} from "../../../redux/slice/settingSlice";
import { useToast } from "../../../context/TostContext";
import CommonButton from "../../../components/commonButton";
import InputField from "../../../components/form/InputField";
import { Card } from "react-bootstrap";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.settings);
  const [errors, setErrors] = useState({});
  const toast = useToast();
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });


  const handleChange = (e) => {
    const { id, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [id]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [id]: "",
    }));
  };



  const validate = () => {
    const newErrors = {};

    if (!form.currentPassword) {
      newErrors.currentPassword = "Current password is required";
    }

    if (!form.newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (form.newPassword.length < 8) {
      newErrors.newPassword = "Password must be at least 8 characters";
    }

    if (!form.confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (form.newPassword !== form.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    dispatch(
      changePassword({
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
      })
    ).then((res) => {
      if (res.payload.success) {
        toast.success(res.payload.message);
        setForm({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      }
      else {
        toast.error(res.payload?.message || "Failed to change password");
      }
    }).catch((err) => {
      toast.error(err?.message || "Something went wrong");
    })
  };

  return (
    <>
      <Card className="password-grid p-4 rounded-2 common-shadow bg-white border-0 w-100" style={{ maxWidth: "460px" }}>
        <Card.Header className="bg-transparent fs-lg p-0 border-0 mb-2">Change Password</Card.Header>
        <Card.Body className="p-0 d-flex flex-column gap-3">

          {/* CURRENT PASSWORD */}
          <InputField label={{ name: "Current Password" }}
            input={{
              id: "currentPassword",
              name: "currentPassword",
              type: "password",
              placeholder: "Enter Current Password...",
              value: form.currentPassword,
              autoFocus: true,
              onChange: handleChange,
            }}
            validation={{
              isInvalid: !!errors.currentPassword,
              message: errors.currentPassword,
            }} />

          {/* NEW PASSWORD */}
          <InputField label={{ name: "New Password" }}
            input={{
              id: "newPassword",
              name: "newPassword",
              type: "password",
              placeholder: "Enter New Password...",
              value: form.newPassword,
              onChange: handleChange,
            }}
            validation={{
              isInvalid: !!errors.newPassword,
              message: errors.newPassword,
            }} />
          {/* CONFIRM PASSWORD */}

          <InputField label={{ name: "Confirm New Password" }}
            input={{
              id: "confirmPassword",
              name: "confirmPassword",
              type: "password",
              placeholder: "Confirm New Password...",
              value: form.confirmPassword,
              onChange: handleChange,
            }}
            validation={{
              isInvalid: !!errors.confirmPassword,
              message: errors.confirmPassword,
            }} />
        </Card.Body>

        <Card.Footer className="d-flex gap-3 justify-content-end bg-transparent px-0 pb-0 pt-3 mt-3">
          <CommonButton
            title="Cancel"
            variant="outline"
            onClick={() =>
              setForm({
                currentPassword: "",
                newPassword: "",
                confirmPassword: "",
              })
            }
          />
          <CommonButton
            title={"Change Password"}
            variant="primary"
            onClick={handleSubmit}
            disabled={isLoading}
          />

        </Card.Footer>
      </Card>
    </>
  );
};

export default ChangePassword;
